import { Helmet } from "react-helmet";
import { useLandingCL } from "./landing-cl.hook";
import { Section3, Section5, Section6 } from "./sections";
import {
  ProductTitle,
  ProductDescription,
  BuyProductPolicy,
} from "../components";

export const LandingCL = () => {
  const { t } = useLandingCL();

  return (
    <div className="bg-f5f5f5">
      <Helmet>
        <title>{t("meta.landing.title")}</title>
        <meta name="description" content={t("meta.landing.description")} />
      </Helmet>
      <div className="section-margin-large">
        <ProductTitle status="landing.section1.status" />
      </div>
      <hr className="landing-separator" />
      <div className="section-margin-large mb-md-5 pb-5">
        <ProductDescription
          descriptions={[
            "landing.section2.description",
            "landing.section2.description2",
          ]}
        />
      </div>
      <div className="section-padding-small mb-5">
        <Section3 />
      </div>
      <div className="section-padding-small section4-padding bg-e5e5e5">
        <BuyProductPolicy />
      </div>
      <div className="section-padding-small section5-padding">
        <Section5 />
      </div>
      <hr className="landing-separator-large" />
      <div className="section-padding-small landing-margin">
        <Section6 />
      </div>
    </div>
  );
};
